import { useState, useEffect } from 'react';
import { AuthService } from '../services/auth.service';

interface TokenExpirationInfo {
  isExpired: boolean;
  timeUntilExpiration: number;
  shouldRefresh: boolean;
  expirationDate: Date | null;
}

export const useTokenExpiration = (): TokenExpirationInfo => {
  const [tokenInfo, setTokenInfo] = useState<TokenExpirationInfo>({
    isExpired: false,
    timeUntilExpiration: 0,
    shouldRefresh: false,
    expirationDate: null,
  });

  useEffect(() => {
    const updateTokenInfo = () => {
      const isExpired = AuthService.isTokenExpired();
      const timeUntilExpiration = AuthService.getTimeUntilExpiration();
      const shouldRefresh = AuthService.shouldRefreshToken();
      const expirationDate = AuthService.getTokenExpiration();

      setTokenInfo({
        isExpired,
        timeUntilExpiration,
        shouldRefresh,
        expirationDate,
      });
    };

    // Cập nhật ngay lập tức
    updateTokenInfo();

    // Cập nhật mỗi 30 giây
    const interval = setInterval(updateTokenInfo, 30000);

    return () => clearInterval(interval);
  }, []);

  return tokenInfo;
};
